module.exports = "/cyber/_next/static/images/snow-6e2aad5b1821b7c1916852534a0083fb.png";